import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ICameraChannel } from "@app/main/components/videos/models/ICameraChannel";
import { ConstantsService } from "@app/services/constantsService";
import { Observable } from "rxjs";
import { IProcessResult } from "../../foundation/foundation.interfaces";

export interface IVideoChannelQueryOptions {
    Id?: number;
    ChannelId?: number;
    VehicleId?: number;
    AccountId?: number;
    IsActive?: boolean;
}

export interface IChannelThumbnail {

    Guid?: string;
    ChannelId?: number;
    Time?: Date;
}

@Injectable({
    providedIn: 'root'
})
export class CameraChannelService {
    apiUrl: string

    constructor(
        private readonly http: HttpClient,
        private readonly constantsService: ConstantsService
    ) {}

    getCameraChannels(options: IVideoChannelQueryOptions = {}): Observable<ICameraChannel[]> {
        return this.http.get<ICameraChannel[]>(`/api/cameras/channels`, { params: options as HttpParams });
    }

    updateCameraChannels(channels: ICameraChannel[]): Observable<ICameraChannel[]> {
        return this.http.post<ICameraChannel[]>(`/api/cameras/channels`, channels)
    }

    getChannelThumbnails(vehicleId: number): Observable<IChannelThumbnail[]> {
        return this.http.get<IChannelThumbnail[]>(`/api/cameras/channels/thumbnails/${vehicleId}`);
    }

    getCommissionChannels(peripheralSerial: string, vehicleId: number): Observable<ICameraChannel[]> {
        return this.http.get<ICameraChannel[]>(`/api/cameras/channels/commissioncamerachannels`, { params: {  peripheralSerial, vehicleId } })
    }

    saveCommissionChannels(channels: ICameraChannel[]): Observable<IProcessResult> {
        return this.http.post<IProcessResult>(`/api/cameras/channels/commissioncamerachannels`, channels);
    }

    createMediaGuidUrl(guid: string): string {
        if (!guid) {
            return null;
        }

        return `${this.constantsService.getApiUrl()}/api/cameras/media/${guid}`;
    }
}
